import type { AnnouncementStyleDefinition, AnnouncementStyleName } from '../announcement-style';
import { ClassicCard } from './classic';
import { ExtraEditionCard } from './extra-edition';
import { IssueCoverCard } from './issue-cover';
import { SchoolLetterCard } from './school-letter';
import { WallNoteCard } from './wall-note';

/** Every announcement card, keyed by the style name stored on the announcement. */
export const ANNOUNCEMENT_STYLE_CARDS: Record<AnnouncementStyleName, AnnouncementStyleDefinition> = {
  classic: { Card: ClassicCard },
  'issue-cover': { Card: IssueCoverCard },
  'wall-note': { Card: WallNoteCard },
  'school-letter': { Card: SchoolLetterCard },
  'extra-edition': { Card: ExtraEditionCard, sheetOnMobile: true },
};

export { ClassicCard, ExtraEditionCard, IssueCoverCard, SchoolLetterCard, WallNoteCard };
